// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__20ocn","subheader":"ReorderModal_subheader__3_1TJ","listWrap":"ReorderModal_listWrap__1g-tA"};